import { transparentize } from 'polished';
import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';

export enum ALERT_THEMES {
  info = 'info',
  success = 'success',
  warning = 'warning',
  danger = 'danger',
  error = 'error',
}

const ALERT_THEME_COLORS = {
  [ALERT_THEMES.info]: BRAND_COLORS.blue,
  [ALERT_THEMES.success]: BRAND_COLORS.darkGreen,
  [ALERT_THEMES.warning]: BRAND_COLORS.yellow,
  [ALERT_THEMES.danger]: BRAND_COLORS.red,
  [ALERT_THEMES.error]: BRAND_COLORS.darkRed,
};

const getStylesForTheme = ({ theme }: { theme: ALERT_THEMES; }) => {
  const color = ALERT_THEME_COLORS[theme];

  return css`
    background: ${transparentize(0.8, color)};
    color: ${color};
  `;
};

interface AlertWrapperProps {
  theme: ALERT_THEMES;
}

export const AlertWrapper = styled.div<AlertWrapperProps>`
  display: flex;
  padding: 6px 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  border-radius: 8px;

  ${TYPOGRAPHY.CIRCULAR.bold}

  font-size: 14px;
  line-height: 20px;

  ${getStylesForTheme}
`;
